module.exports = __webpack_public_path__ + "img/thin-farm-thumb.f1828bfd.jpg";